/* This file is autogenerated, see readme.md for instructions */
import DragHorizontalSvgIcon from '@bloomreach/banana-theme/icons/drag-horizontal.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DragHorizontalIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DragHorizontalSvgIcon />
    </Icon>
  );
});

DragHorizontalIcon.displayName = 'DragHorizontalIcon';

export default DragHorizontalIcon;
